import React from 'react';

function MoveCenter({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M16 7L16 25" />
      <path d="M7 21L12 16L7 11" />
      <path d="M25 21L20 16L25 11" />
    </svg>
  );
}

export default MoveCenter;
